import {classInstance} from '@/shared/helpers/helpers';

export class CatalogLayout {
	private readonly element: HTMLElement;
	private readonly filterOpenerSelector: string = '.catalog-layout__filter-opener';
	private readonly filterCloseSelector: string = '.catalog-filter__close';
	private readonly activeFilterClass: string = 'catalog-layout--filter';

	constructor(element: HTMLElement) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleClick = ({ target }): void => {
		if (target.closest(this.filterOpenerSelector)) this.element.classList.add(this.activeFilterClass);
		else if (target.closest(this.filterCloseSelector)) this.element.classList.remove(this.activeFilterClass);
	};

	public init = (): void => {
		classInstance.set(this.element, { catalog: this });
		this.element.addEventListener('click', this.handleClick);
	};

	public destroy = (): void => {
		classInstance.del(this.element, 'catalog');
		this.element.removeEventListener('click', this.handleClick);
	};
}
